import { Card, FAQ } from './types';

export const cards: Card[] = [
  {
    id: 1,
    icon: 'card-icon-shipping-leads.svg',
    title: 'Verified Global Partnerships',
    description: 'Collaborate with thoroughly screened members, ensuring reliability and trust in every partnership.',
    alt: 'Verified Global Partnerships',
  },
  {
    id: 2,
    icon: 'card-icon-networking.svg',
    title: 'Enhanced Service Reliability',
    description: 'Access the best digital tools for logistics for enhanced operational efficiency, cargo tracking and more. Deliver consistent, high-quality services to your clients, supported by leading logistics providers worldwide.',
    alt: 'Service Reliability',
  },
  {
    id: 3,
    icon: 'card-icon-support.svg',
    title: 'Seamless Communication',
    description: 'Engage with members through our Virtual Office, sharing experiences and seeking partners in a reliable, trusted and guaranteed networking environment.',
    alt: 'Seamless Communication',
  },
  {
    id: 4,
    icon: 'card-icon-digital-tools.svg',
    title: 'Rate Sharing Opportunities',
    description: 'Expand your service offerings by subscribing to and reselling rates from international members, negotiating a partial commission, and consequently increasing your market reach.',
    alt: 'Rate Sharing Opportunities',
  },
  {
    id: 5,
    icon: 'card-icon-brand-reliability.svg',
    title: 'Support Around the Clock',
    description: 'Access 24/7 assistance to ensure smooth operations and address any challenges promptly.',
    alt: 'Support Around the Clock',
  },
];

export const faq: FAQ[] = [
  {
    id: "1",
    question: "How does DFA verify its members?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Each member undergoes a rigorous screening process to ensure they meet our high standards of reliability and professionalism.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "Can I communicate directly with other members?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Yes, our Virtual Office enables direct communication, allowing you to share experiences and collaborate effectively.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "How can rate sharing benefit my business?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          By subscribing to and reselling rates from other members, you can offer competitive pricing and expand your service offerings, attracting a broader customer base.
        </p>
      `
    ),
  },
  {
    id: "4",
    question: "What kind of support does DFA provide?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          We offer 24/7 support to assist with any operational challenges, ensuring your business runs smoothly.
        </p>
      `
    ),
  },
  {
    id: "5",
    question: "Is there a fee to join DFA's network?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Please visit our Membership Page for detailed information on membership fees and benefits.
        </p>
      `
    ),
  },
  {
    id: "6",
    question: "How can networking with DFA improve my service reliability?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Partnering with our verified members allows you to deliver services that meet world-class standards, enhancing your reputation and customer satisfaction.
        </p>
      `
    ),
  },
  {
    id: "7",
    question: "What tools are available to facilitate networking?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          DFA provides digital tools such as the Virtual Office for communication, as well as resources for rate sharing and operational support.
        </p>
      `
    ),
  },
];